export default __webpack_public_path__ + "static/media/pisi.76652e6d.jpg";